import React, { Component } from "react";
import commonFunction from "../../../lib/utils/common";
import configUrl from "../../../../config/config.json";
import { logout } from "../../../lib/logout";
import Menu from "../../Menu/index";
import Link from "../../../Link";
import chat from "../../../lib/chat";

let MenuList = [
  {
    linkItem: "My Profile",
    componentName: "ProfileForm",
    imgInActiveSrc: "/images/my-profile-g.svg",
    imgActiveSrc: "https://c.animaapp.com/m99osmhbgyfn9q/img/my-clients.svg",
    activeTabStatus: true,
    activeTab: "myprofile",
  },
  {
    linkItem: "Agency Profile",
    componentName: "AgencyProfile",
    imgInActiveSrc: "/images/my-profile-g.svg",
    imgActiveSrc: "https://c.animaapp.com/m99osmhbgyfn9q/img/agency.svg",
    activeTabStatus: false,
    activeTab: "agencyprofile",
  },
  {
    linkItem: "Bookings",
    componentName: "BookingForm",
    imgInActiveSrc: "/images/my-booking-g.svg",
    imgActiveSrc: "https://c.animaapp.com/m99osmhbgyfn9q/img/list.svg",
    activeTabStatus: false,
    activeTab: "mybooking",
  },
    {
    linkItem: "Import PNR",
    componentName: "ImportPnr",
    imgInActiveSrc: "/images/my-booking-g.svg",
    imgActiveSrc: "images/import.svg",
    activeTabStatus: false,
    activeTab: "importpnr",
  },
    {
    linkItem: "Payment Receipt",
    componentName: "PaymentReceipt",
    imgInActiveSrc: "/images/wallet-01.svg",
    imgActiveSrc: "https://c.animaapp.com/m99osmhbgyfn9q/img/aed.svg",
    activeTabStatus: false,
    activeTab: "paymentreceipt",
  },

  {
    linkItem: "Clients",
    componentName: "MyClients",
    imgInActiveSrc: "/images/guestTravel-g.svg",
    imgActiveSrc: "https://c.animaapp.com/m99osmhbgyfn9q/img/client.svg",
    activeTabStatus: false,
    activeTab: "myclients",
  },
  {
    linkItem: "Feedback",
    componentName: "Feedback",
    imgInActiveSrc: "/images/guestTravel-g.svg",
    imgActiveSrc: "https://c.animaapp.com/m99osmhbgyfn9q/img/feedbacks.svg",
    activeTabStatus: false,
    activeTab: "feedback",
  },
  {
    linkItem: "Manage Staff",
    componentName: "ManageStaff",
    imgInActiveSrc: "/images/changePwd-g.svg",
    imgActiveSrc: "https://c.animaapp.com/m99osmhbgyfn9q/img/manage-staff.svg",
    activeTabStatus: false,
    activeTab: "managestaff",
  },
  {
    linkItem: "Reports",
    componentName: "Reports",
    imgInActiveSrc: "/images/report-01.svg",
    imgActiveSrc: "https://c.animaapp.com/m99osmhbgyfn9q/img/reports.svg",
    activeTabStatus: false,
    activeTab: "reports",
    activeTabReport: true,
  },
  {
    linkItem: "Bank Details",
    componentName: "BankDetails",
    imgInActiveSrc: "/images/guestTravel-g.svg",
    imgActiveSrc: "https://c.animaapp.com/m99osmhbgyfn9q/img/bank-details.svg",
    activeTabStatus: false,
    activeTab: "bankdetails",
  },
  {
    linkItem: "Settings",
    componentName: "Settings",
    imgInActiveSrc: "/images/setting-01.svg",
    imgActiveSrc: "https://c.animaapp.com/m99osmhbgyfn9q/img/settings.svg",
    activeTabStatus: false,
    activeTab: "settings",
  },
  {
    linkItem: "Logout",
    componentName: "Logout",
    imgInActiveSrc: "/images/Logout-g.svg",
    imgActiveSrc: "https://c.animaapp.com/m99osmhbgyfn9q/img/logout-.svg",
    activeTabStatus: false,
    activeTab: "logout",
  },
];
class MobileHeader1 extends Component {
  constructor(props) {
    super(props);
    
    // Create a copy of MenuList to avoid mutating the original
    let filteredMenuList = [...MenuList];
    
    // Filter based on user type (existing logic)
    if (props?.data?.user?.user_type !== "ADMIN") {
      filteredMenuList = filteredMenuList.filter(
        (item) =>
          item.linkItem !== "Settings" &&
          item.linkItem !== "Manage Staff" &&
          item.linkItem !== "Payment Receipt" &&
          item.linkItem !== "Agency Profile"
      );
      console.log("user is notADMIN");
    }
    
    // Filter Import PNR based on cms_services
    if (!props?.data?.user?.cms_services?.flight?.import_pnr) {
      filteredMenuList = filteredMenuList.filter(
        (item) => item.linkItem !== "Import PNR"
      );
    }
    
    console.log("Filtered MenuList:", filteredMenuList);
    
    this.state = {
      isToken: "",
      isShowPopup: false,
      userFirststname: "",
      open: false,
      MenuList: filteredMenuList,
    };
  }
  componentDidMount() {
    chat(this.props?.data?.siteData?.site?.chat, this.props?.data?.isMobile);
    if (this.props?.data?.user?.status) {
      this.setState({
        userFirststname: this.props?.data?.user?.first_name
          ? this.props?.data?.user?.first_name.charAt(0)
          : this.props?.data?.user?.email.charAt(0),
        newToken: this.props?.data?.user?.accessToken || "",
      });
    } else {
      this.setState({
        userFirststname: "",
        newToken: "",
      });
    }
  }

  onClickArrow = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup,
    });
  };
  onMouseLeave = () => {
    this.setState({
      isShowPopup: false,
    });
  };

  onClickProfile = () => {
    commonFunction.redirectTo("/myprofile");
  };
  onClickLogout = () => {
    logout()
      .then((responseJSON) => {
        if (
          responseJSON.status &&
          responseJSON.message === "Logout successfull"
        ) {
          this.setState({
            newToken: "",
            userFirststname: "",
          });
          location.reload();
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  onClickMenu = (bool) => {
    this.setState({ open: bool });
  };

  onClickTab = (id) => {
    let newdata = this.state.MenuList.map((fact, index) => {
      if (id == index) {
        let data = {
          ...fact,
          activeTabStatus: true,
        };
        return data;
      } else {
        let data = {
          ...fact,
          activeTabStatus: false,
        };
        return data;
      }
    });

    this.setState({ MenuList: newdata });
    this.setState({ open: false });
  };
  render() {
    return (
      <>
        {window.location.pathname !== "/login" && (
          <header className="mobile-header">
            <div className={this.props.data.cssfile.main_logo_header}>
              <div className={this.props.data.cssfile.logo_flex}>
                <div className={this.props.data.cssfile.logosub_header}>
                  {window.location.pathname !== "/login" &&
                  (this.props?.data?.headermenu?.is_show_login == undefined ||
                    this.props?.data?.headermenu?.is_show_login) ? (
                    this.state.newToken != undefined &&
                    this.state.newToken != null &&
                    this.state.newToken != "" ? (
                      <div
                        className={this.props.data.cssfile.afterlogin}
                        onClick={() => {
                          this.onClickMenu(!this.state.open);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="15"
                          viewBox="0 0 21 15"
                          fill="none"
                        >
                          <path
                            d="M19.7143 8.35735L0.857143 8.35735C0.342857 8.35735 0 8.0145 0 7.50021C0 6.98592 0.342857 6.64307 0.857143 6.64307L19.7143 6.64307C20.2286 6.64307 20.5714 6.98592 20.5714 7.50021C20.5714 8.0145 20.2286 8.35735 19.7143 8.35735Z"
                            fill="#212121"
                          />
                          <path
                            d="M19.7143 2.35735L0.857143 2.35735C0.342857 2.35735 0 2.0145 0 1.50021C0 0.985924 0.342857 0.643066 0.857143 0.643066L19.7143 0.643066C20.2286 0.643066 20.5714 0.985924 20.5714 1.50021C20.5714 2.0145 20.2286 2.35735 19.7143 2.35735Z"
                            fill="#212121"
                          />
                          <path
                            d="M19.7143 14.3574L0.857143 14.3574C0.342857 14.3574 0 14.0145 0 13.5002C0 12.9859 0.342857 12.6431 0.857143 12.6431L19.7143 12.6431C20.2286 12.6431 20.5714 12.9859 20.5714 13.5002C20.5714 14.0145 20.2286 14.3574 19.7143 14.3574Z"
                            fill="#212121"
                          />
                        </svg>
                      </div>
                    ) : (
                      <span
                        className={this.props.data.cssfile.login_btn}
                        onClick={this.props.data.onClickHeaderLogin}
                      >
                        <img
                          className={this.props.data.cssfile.login_icon}
                          src="images/user-login-mob1.svg"
                          onClick={this.props.data.onClickHeaderLogin}
                          alt=""
                        />
                      </span>
                    )
                  ) : (
                    []
                  )}

                  {window.location.pathname !== "/login" && (
                    <>
                      <Menu
                        theme="theme10"
                        clickedTab={this.onClickTab}
                        onclickLogout={this.onClickLogout}
                        styles={this.props.data.menucssfile}
                        isopen={this.state.open}
                        MenuList={this.state.MenuList}
                        id={"main-menu"}
                        pathname={
                          this.props.data.pathname === "/myprofile"
                            ? new URLSearchParams(window.location.search).get(
                                "Linkindex"
                              ) !== null
                              ? this.props.data.pathname
                              : "myprofile"
                            : this.props.data.pathname
                        }
                        closeMenusHandler={this.onClickMenu}
                        branchName={this.props?.data?.user?.organisation?.name}
                        data={this.props.data}
                      />
                    </>
                  )}
                </div>
                <div className={this.props.data.cssfile.logo_header}>
                  {window.location.pathname !== "/login" && (
                    <Link key={""} href={"/"} className="">
                      <h1>
                        <img
                          className={this.props?.data?.cssfile?.header_logo}
                          src={`${
                            "/shared/api/media/" +
                            this.props.data.headermenu.logo
                          }`}
                          alt="logo"
                        />
                      </h1>
                    </Link>
                  )}
                  {window.location.pathname == "/login" && (
                    <h1>
                      <img
                        className={this.props?.data?.cssfile?.header_logo}
                        src={`${
                          "/shared/api/media/" + this.props.data.headermenu.logo
                        }`}
                        alt="logo"
                      />
                    </h1>
                  )}
                </div>
              </div>
              <div className={this.props.data.cssfile.header_notification}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="23"
                  viewBox="0 0 22 23"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.933 16.8335H19.9303V9.36683C19.9303 4.654 16.1098 0.833496 11.397 0.833496C6.68416 0.833496 2.86366 4.654 2.86366 9.36683V16.8335H1.91432C1.32522 16.8335 0.847656 17.3111 0.847656 17.9002C0.847656 18.4893 1.32522 18.9668 1.91432 18.9668H8.19699C8.19699 20.7341 9.62968 22.1668 11.397 22.1668C13.1643 22.1668 14.597 20.7341 14.597 18.9668H20.933C21.5221 18.9668 21.9997 18.4893 21.9997 17.9002C21.9997 17.3111 21.5221 16.8335 20.933 16.8335ZM11.3987 20.0335C10.8096 20.0335 10.332 19.5559 10.332 18.9668H12.4654C12.4654 19.5559 11.9878 20.0335 11.3987 20.0335ZM4.99609 16.8335H13.5294H17.7961V9.3668C17.7961 5.83217 14.9307 2.9668 11.3961 2.9668C7.86147 2.9668 4.99609 5.83217 4.99609 9.3668V16.8335Z"
                    fill="#003366"
                  />
                  <circle cx="17" cy="5.8335" r="4" fill="#C8102E" />
                </svg>
              </div>
            </div>
          </header>
        )}
      </>
    );
  }
}

export default MobileHeader1;
